import i18n from "./config";

/**
 * The Gemeinde's `defaultLanguage` (GOD-50) applies until the person picks a
 * language themselves with the switch in the sidebar. The browser detector
 * stores every language it sets, so the explicit choice needs its own flag.
 */
const CHOSEN_KEY = "serva.languageChosen";

export function markLanguageChosen(): void {
    try {
        localStorage.setItem(CHOSEN_KEY, "1");
    } catch {
        // Storage blocked: the choice only lasts for this page view.
    }
}

function languageChosen(): boolean {
    try {
        return localStorage.getItem(CHOSEN_KEY) === "1";
    } catch {
        return false;
    }
}

/** Switches to the Gemeinde's language unless the person chose one. */
export function applyGemeindeLanguage(language: string | null | undefined): void {
    if (language !== "de" && language !== "en") return;
    if (languageChosen()) return;
    const current = (i18n.resolvedLanguage || i18n.language || "de").split("-")[0];
    if (current !== language) void i18n.changeLanguage(language);
}
